import fEUserProfile from '../assets/icons/fEUserProfile.png'

const userWiseRole = {
  admin: 1,
  productManufacture: 2,
  digitalRetailer: 3,
  dealer: 4,
  customer: 5,
  transporter: 6,
  dealerUser: 7,
  contractor: 8,
  fieldEngineer: 9,
}

const childUsers = [userWiseRole.dealerUser, userWiseRole.fieldEngineer]

const userDataList = userType => {
  switch (userType) {
    case 'ADMIN':
    case 'admin':
      return [
        {
          id: 235726,
          city: 'New York',
          state: 'New York',
          country: 'jp',
          firstName: null,
          lastName: 'David',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
          creationDate: 1683708390593,
          modificationDate: 0,
          emailId: 'davis.lawson@gmail.com',
          emailId1: '',
          emailId2: '',
          emailId3: '',
          emailId4: '',
          emailId5: '',
          emailId6: '',
          emailId7: '',
          emailId8: '',
          emailId9: '',
          emailId10: '',
          phoneNumber: '+1-6-1234-5678',
          roleId: 1,
          address: '438 West 37th Street',
          adminId: 94,
          superAdminId: null,
          blocked: false,
          webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
          fullCount: 1,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'David lawson',
          pincode: 10018,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: '',
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: null,
          inchargePerson: null,
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
      ]
    case 'product-manufacture':
      return [
        {
          id: 235726,
          city: 'New York',
          state: 'New York',
          country: 'jp',
          firstName: null,
          lastName: 'David a',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
          creationDate: 1683708390593,
          modificationDate: 0,
          emailId: 'davis.lawson@gmail.com',
          emailId1: '',
          emailId2: '',
          emailId3: '',
          emailId4: '',
          emailId5: '',
          emailId6: '',
          emailId7: '',
          emailId8: '',
          emailId9: '',
          emailId10: '',
          phoneNumber: '+1-6-1234-5678',
          roleId: 2,
          address: '438 West 37th Street',
          adminId: 94,
          superAdminId: null,
          blocked: false,
          webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
          fullCount: 1,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'sdasdasd David lawson',
          pincode: 10018,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: '',
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: null,
          inchargePerson: null,
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
      ]
    case 'digital-retailer':
      return [
        {
          id: 235726,
          city: 'New York',
          state: 'New York',
          country: 'jp',
          firstName: null,
          lastName: 'digital retailer',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
          creationDate: 1683708390593,
          modificationDate: 0,
          emailId: 'davis.lawson@gmail.com',
          emailId1: '',
          emailId2: '',
          emailId3: '',
          emailId4: '',
          emailId5: '',
          emailId6: '',
          emailId7: '',
          emailId8: '',
          emailId9: '',
          emailId10: '',
          phoneNumber: '+1-6-1234-5678',
          roleId: 3,
          address: '438 West 37th Street',
          adminId: 94,
          superAdminId: null,
          blocked: false,
          webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
          fullCount: 1,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'sdasdasd David lawson',
          pincode: 10018,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: '',
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: null,
          inchargePerson: null,
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
      ]
    case 'transporter':
      return [
        {
          id: 235726,
          city: 'New York',
          state: 'New York',
          country: 'jp',
          firstName: null,
          lastName: 'transporter',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
          creationDate: 1683708390593,
          modificationDate: 0,
          emailId: 'davis.lawson@gmail.com',
          emailId1: '',
          emailId2: '',
          emailId3: '',
          emailId4: '',
          emailId5: '',
          emailId6: '',
          emailId7: '',
          emailId8: '',
          emailId9: '',
          emailId10: '',
          phoneNumber: '+1-6-1234-5678',
          roleId: 6,
          address: '438 West 37th Street',
          adminId: 94,
          superAdminId: null,
          blocked: false,
          webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
          fullCount: 1,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'sdasdasd David lawson',
          pincode: 10018,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: '',
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: null,
          inchargePerson: null,
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
      ]
    case 'DEALER':
    case 'dealer':
      return [
        {
          id: 311764,
          city: 'Kuala Lumpur',
          state: 'Kuala Lumpur',
          country: 'my',
          firstName: '',
          lastName: null,
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690785802692.png',
          creationDate: 1690785802771,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 4,
          address: 'Room 1404, Wisma Lim Foo Yong, 86\r\nJalan Raja Chulan',
          adminId: 235726,
          superAdminId: null,
          blocked: false,
          webId: '75626fd4-9b8d-4b32-bb08-e5b58470df5f',
          fullCount: 17,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Toyota Tsusho (Malaysia) Sdn. Bhd.',
          pincode: 50200,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
          parent: {
            id: 235726,
            city: '千代田区',
            state: '東京都',
            country: 'jp',
            firstName: null,
            lastName: '管理　太郎',
            profileUrl:
              'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
            creationDate: 1683708390593,
            modificationDate: 0,
            emailId: 'refnext.test1@gmail.com',
            emailId1: '',
            emailId2: '',
            emailId3: '',
            emailId4: '',
            emailId5: '',
            emailId6: '',
            emailId7: '',
            emailId8: '',
            emailId9: '',
            emailId10: '',
            phoneNumber: '+81-6-1234-5678',
            roleId: 1,
            address: '千代田1-2-3',
            adminId: 94,
            superAdminId: null,
            blocked: false,
            webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
            fullCount: null,
            category: null,
            devices: null,
            averageRating: 0,
            oneRating: null,
            twoRating: null,
            threeRating: null,
            fourRating: null,
            fiveRating: null,
            ratingCount: null,
            totalReview: null,
            businessName: 'テスト商用版(管理者)',
            pincode: 1000001,
            jobCountBetweenAssociateUsers: null,
            businessOwnerIdUrl: null,
            businessCertificateUrl: null,
            corporateIdentificationNumber: '',
            restrictedJobType: null,
            permittedJobType: [],
            inchargeDepartment: null,
            inchargePerson: null,
            businessNameReport: null,
            stateReport: null,
            cityReport: null,
            addressReport: null,
            pincodeReport: null,
            digitalSignature: null,
            signatureDisplay: false,
            parent: null,
          },
        },
        {
          id: 311602,
          city: 'Selangor',
          state: 'Selangor',
          country: 'my',
          firstName: '',
          lastName: null,
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690784411176.png',
          creationDate: 1690784411271,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 4,
          address:
            'No.6, Jalan MJ14, Taman Industri Meranti Jaya, 47120 Puchong, Selangor, Malaysia',
          adminId: 235726,
          superAdminId: null,
          blocked: false,
          webId: '9d3fe641-3283-4db8-8167-1e65ab37f859',
          fullCount: 17,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Lima Technologies (M) Sdn Bhd',
          pincode: 47120,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
          parent: {
            id: 235726,
            city: '千代田区',
            state: '東京都',
            country: 'jp',
            firstName: null,
            lastName: '管理　太郎',
            profileUrl:
              'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
            creationDate: 1683708390593,
            modificationDate: 0,
            emailId: 'refnext.test1@gmail.com',
            emailId1: '',
            emailId2: '',
            emailId3: '',
            emailId4: '',
            emailId5: '',
            emailId6: '',
            emailId7: '',
            emailId8: '',
            emailId9: '',
            emailId10: '',
            phoneNumber: '+81-6-1234-5678',
            roleId: 1,
            address: '千代田1-2-3',
            adminId: 94,
            superAdminId: null,
            blocked: false,
            webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
            fullCount: null,
            category: null,
            devices: null,
            averageRating: 0,
            oneRating: null,
            twoRating: null,
            threeRating: null,
            fourRating: null,
            fiveRating: null,
            ratingCount: null,
            totalReview: null,
            businessName: 'テスト商用版(管理者)',
            pincode: 1000001,
            jobCountBetweenAssociateUsers: null,
            businessOwnerIdUrl: null,
            businessCertificateUrl: null,
            corporateIdentificationNumber: '',
            restrictedJobType: null,
            permittedJobType: [],
            inchargeDepartment: null,
            inchargePerson: null,
            businessNameReport: null,
            stateReport: null,
            cityReport: null,
            addressReport: null,
            pincodeReport: null,
            digitalSignature: null,
            signatureDisplay: false,
            parent: null,
          },
        },
        {
          id: 311598,
          city: 'Kuala Lumpur',
          state: 'Kuala Lumpur',
          country: 'my',
          firstName: '',
          lastName: null,
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690783527486.png',
          creationDate: 1690783527631,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 4,
          address: 'No. 2, Jalan Landak, Off Jalan Pudu',
          adminId: 235726,
          superAdminId: null,
          blocked: false,
          webId: '16e8cf5f-c4ae-421f-a7c8-fb16d7bdfe79',
          fullCount: 17,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Cool & Hot Home Appliances Sdn Bhd',
          pincode: 55100,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
          parent: {
            id: 235726,
            city: '千代田区',
            state: '東京都',
            country: 'jp',
            firstName: null,
            lastName: '管理　太郎',
            profileUrl:
              'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
            creationDate: 1683708390593,
            modificationDate: 0,
            emailId: 'refnext.test1@gmail.com',
            emailId1: '',
            emailId2: '',
            emailId3: '',
            emailId4: '',
            emailId5: '',
            emailId6: '',
            emailId7: '',
            emailId8: '',
            emailId9: '',
            emailId10: '',
            phoneNumber: '+81-6-1234-5678',
            roleId: 1,
            address: '千代田1-2-3',
            adminId: 94,
            superAdminId: null,
            blocked: false,
            webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
            fullCount: null,
            category: null,
            devices: null,
            averageRating: 0,
            oneRating: null,
            twoRating: null,
            threeRating: null,
            fourRating: null,
            fiveRating: null,
            ratingCount: null,
            totalReview: null,
            businessName: 'テスト商用版(管理者)',
            pincode: 1000001,
            jobCountBetweenAssociateUsers: null,
            businessOwnerIdUrl: null,
            businessCertificateUrl: null,
            corporateIdentificationNumber: '',
            restrictedJobType: null,
            permittedJobType: [],
            inchargeDepartment: null,
            inchargePerson: null,
            businessNameReport: null,
            stateReport: null,
            cityReport: null,
            addressReport: null,
            pincodeReport: null,
            digitalSignature: null,
            signatureDisplay: false,
            parent: null,
          },
        },
        {
          id: 311309,
          city: 'Ding Daeng',
          state: 'Bangkok',
          country: 'th',
          firstName: '',
          lastName: null,
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690777050117.png',
          creationDate: 1690777050235,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 4,
          address: '607 Asoke-Dindaeng Road,Kwaeng Dindaeng,Khet Dindaeng',
          adminId: 235726,
          superAdminId: null,
          blocked: false,
          webId: 'e1755287-b270-482a-a24e-66616789c867',
          fullCount: 17,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Toyota Tsusho Thailand',
          pincode: 10400,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
          parent: {
            id: 235726,
            city: '千代田区',
            state: '東京都',
            country: 'jp',
            firstName: null,
            lastName: '管理　太郎',
            profileUrl:
              'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
            creationDate: 1683708390593,
            modificationDate: 0,
            emailId: 'refnext.test1@gmail.com',
            emailId1: '',
            emailId2: '',
            emailId3: '',
            emailId4: '',
            emailId5: '',
            emailId6: '',
            emailId7: '',
            emailId8: '',
            emailId9: '',
            emailId10: '',
            phoneNumber: '+81-6-1234-5678',
            roleId: 1,
            address: '千代田1-2-3',
            adminId: 94,
            superAdminId: null,
            blocked: false,
            webId: 'e029ee66-12e3-456c-86e2-802725600a1e',
            fullCount: null,
            category: null,
            devices: null,
            averageRating: 0,
            oneRating: null,
            twoRating: null,
            threeRating: null,
            fourRating: null,
            fiveRating: null,
            ratingCount: null,
            totalReview: null,
            businessName: 'テスト商用版(管理者)',
            pincode: 1000001,
            jobCountBetweenAssociateUsers: null,
            businessOwnerIdUrl: null,
            businessCertificateUrl: null,
            corporateIdentificationNumber: '',
            restrictedJobType: null,
            permittedJobType: [],
            inchargeDepartment: null,
            inchargePerson: null,
            businessNameReport: null,
            stateReport: null,
            cityReport: null,
            addressReport: null,
            pincodeReport: null,
            digitalSignature: null,
            signatureDisplay: false,
            parent: null,
          },
        },
      ]
    case 'DEALER_USER':
    case 'dealer-user':
      return [
        {
          id: 310543,
          city: 'Waller',
          state: 'Texas',
          country: 'us',
          firstName: '',
          lastName: 'Takeshi Yoshimura',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690711079941.png',
          creationDate: 1690711080052,
          modificationDate: 0,
          emailId: 'refnext.test1@gmail.com',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 7,
          address: 'Daikin Texas Technology Park, 19001 Kermier Road',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: 'd768faa1-cec5-45b9-aaea-6d5d0c425bed',
          fullCount: 1,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: '',
          pincode: 77484,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
          parent: {
            id: 310542,
            city: 'Waller',
            state: 'Texas',
            country: 'us',
            firstName: '',
            lastName: null,
            profileUrl:
              'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690710967971.png',
            creationDate: 1690710968074,
            modificationDate: 0,
            emailId: '',
            emailId1: null,
            emailId2: null,
            emailId3: null,
            emailId4: null,
            emailId5: null,
            emailId6: null,
            emailId7: null,
            emailId8: null,
            emailId9: null,
            emailId10: null,
            phoneNumber: null,
            roleId: 4,
            address: 'Daikin Texas Technology Park, 19001 Kermier Road',
            adminId: 235726,
            superAdminId: null,
            blocked: false,
            webId: '471a9dba-5e94-457d-82d7-63773fdaa675',
            fullCount: null,
            category: null,
            devices: null,
            averageRating: 0,
            oneRating: null,
            twoRating: null,
            threeRating: null,
            fourRating: null,
            fiveRating: null,
            ratingCount: null,
            totalReview: null,
            businessName: 'Daikin Comfort Technologies North America, Inc.',
            pincode: 77484,
            jobCountBetweenAssociateUsers: null,
            businessOwnerIdUrl: null,
            businessCertificateUrl: null,
            corporateIdentificationNumber: null,
            restrictedJobType: null,
            permittedJobType: [],
            inchargeDepartment: '',
            inchargePerson: '',
            businessNameReport: null,
            stateReport: null,
            cityReport: null,
            addressReport: null,
            pincodeReport: null,
            digitalSignature: null,
            signatureDisplay: false,
            parent: null,
          },
        },
      ]
    case 'CONTRACTOR':
    case 'contractor':
      return [
        {
          id: 310547,
          city: 'Tampa',
          state: 'Florida',
          country: 'us',
          firstName: '',
          lastName: 'John Admin',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690712607860.png',
          creationDate: 1690712607967,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 8,
          address: '3711 W. Walnut St.',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: 'd2e032a1-ce08-46b2-b1b4-6b9e2a064973',
          fullCount: 4,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Carroll Air Systems',
          pincode: 33607,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
        {
          id: 310546,
          city: 'Waller',
          state: 'Texas',
          country: 'us',
          firstName: '',
          lastName: 'John Admin',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690712325751.png',
          creationDate: 1690712325852,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 8,
          address: 'Daikin Texas Technology Park, 19001 Kermier Road',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: 'f5874fe3-d57b-4c4e-a619-dbec2e76d31c',
          fullCount: 4,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Daikin Houston',
          pincode: 77484,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
        {
          id: 310545,
          city: 'Riverton',
          state: 'New Jersey',
          country: 'us',
          firstName: '',
          lastName: 'John Admin',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690711688162.png',
          creationDate: 1690711688243,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 8,
          address: '613 Main Street',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: 'd624b136-7855-4958-8aa3-92352fcf0518',
          fullCount: 4,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Tristate HVAC Equipment LLP Riverton',
          pincode: 8077,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
        {
          id: 310544,
          city: 'New York',
          state: 'New York',
          country: 'us',
          firstName: '',
          lastName: 'John Admin',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690711386770.png',
          creationDate: 1690711386848,
          modificationDate: 0,
          emailId: '',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 8,
          address: '438 West 37th Street',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: '4e6b0818-e3f9-4941-974b-3042ea3b2945',
          fullCount: 4,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'ABCO HVACR Supply + Solutions MANHATTAN',
          pincode: 10018,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
      ]
    case 'FIELD_ENGINEER':
    case 'field-engineer':
      return [
        {
          id: 310548,
          city: 'Waller',
          state: 'Texas',
          country: 'us',
          firstName: '',
          lastName: 'Jacob Thomas',
          profileUrl: fEUserProfile,
          creationDate: 1690711080052,
          modificationDate: 0,
          emailId: 'jacob.thomas@yahoo.com',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 9,
          address: 'Daikin Texas Technology Park, 19001 Kermier Road',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: 'd768faa1-cec5-45b9-aaea-6d5d0c425bed',
          fullCount: 1,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: '',
          pincode: 77484,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
        },
      ]
    case 'USER_VIEW_CUSTOMER':
    case 'customer':
      return [
        {
          id: 310549,
          city: 'Riverton',
          state: 'New Jersey',
          country: 'us',
          firstName: '',
          lastName: 'John Admin',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
          creationDate: 1690711688243,
          modificationDate: 0,
          emailId: 'aeron.zemmer@yahoo.com',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 5,
          address: '613 Main Street',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: 'd624b136-7855-4958-8aa3-92352fcf0518',
          fullCount: 4,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          businessName: 'Aeron zemmer',
          pincode: 8077,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
          parent: {
            id: 310542,
            city: 'Waller',
            state: 'Texas',
            country: 'us',
            firstName: '',
            lastName: null,
            profileUrl:
              'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690710967971.png',
            creationDate: 1690710968074,
            modificationDate: 0,
            emailId: '',
            emailId1: null,
            emailId2: null,
            emailId3: null,
            emailId4: null,
            emailId5: null,
            emailId6: null,
            emailId7: null,
            emailId8: null,
            emailId9: null,
            emailId10: null,
            phoneNumber: null,
            roleId: 4,
            address: 'Daikin Texas Technology Park, 19001 Kermier Road',
            adminId: 235726,
            superAdminId: null,
            blocked: false,
            webId: '471a9dba-5e94-457d-82d7-63773fdaa675',
            fullCount: null,
            category: null,
            devices: null,
            averageRating: 0,
            oneRating: null,
            twoRating: null,
            threeRating: null,
            fourRating: null,
            fiveRating: null,
            ratingCount: null,
            totalReview: null,
            businessName: 'Daikin Comfort Technologies North America, Inc.',
            pincode: 77484,
            jobCountBetweenAssociateUsers: null,
            businessOwnerIdUrl: null,
            businessCertificateUrl: null,
            corporateIdentificationNumber: null,
            restrictedJobType: null,
            permittedJobType: [],
            inchargeDepartment: '',
            inchargePerson: '',
            businessNameReport: null,
            stateReport: null,
            cityReport: null,
            addressReport: null,
            pincodeReport: null,
            digitalSignature: null,
            signatureDisplay: false,
            parent: null,
          },
        },
      ]
    case 'BUILDING':
      return [
        {
          id: 310549,
          city: 'Riverton',
          state: 'New Jersey',
          country: 'us',
          firstName: '',
          lastName: 'John Admin ',
          profileUrl:
            'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1683764582903.jpg',
          creationDate: 1690711688243,
          modificationDate: 0,
          emailId: 'aeron.zemmer@yahoo.com',
          emailId1: null,
          emailId2: null,
          emailId3: null,
          emailId4: null,
          emailId5: null,
          emailId6: null,
          emailId7: null,
          emailId8: null,
          emailId9: null,
          emailId10: null,
          phoneNumber: null,
          roleId: 7,
          address: '613 Main Street',
          adminId: 310542,
          superAdminId: null,
          blocked: false,
          webId: 'd624b136-7855-4958-8aa3-92352fcf0518',
          fullCount: 4,
          category: [],
          devices: null,
          averageRating: 0,
          oneRating: 0,
          twoRating: 0,
          threeRating: 0,
          fourRating: 0,
          fiveRating: 0,
          ratingCount: 0,
          totalReview: 0,
          name: 'Aeron zemmer Building',
          pincode: 8077,
          jobCountBetweenAssociateUsers: null,
          businessOwnerIdUrl: null,
          businessCertificateUrl: null,
          corporateIdentificationNumber: null,
          restrictedJobType: null,
          permittedJobType: [],
          inchargeDepartment: '',
          inchargePerson: '',
          businessNameReport: null,
          stateReport: null,
          cityReport: null,
          addressReport: null,
          pincodeReport: null,
          digitalSignature: null,
          signatureDisplay: false,
          parent: {
            id: 310542,
            city: 'Waller',
            state: 'Texas',
            country: 'us',
            firstName: '',
            lastName: null,
            profileUrl:
              'https://d2fq0d0rhuxbmj.cloudfront.net/profile-pic-126852231231/1690710967971.png',
            creationDate: 1690710968074,
            modificationDate: 0,
            emailId: '',
            emailId1: null,
            emailId2: null,
            emailId3: null,
            emailId4: null,
            emailId5: null,
            emailId6: null,
            emailId7: null,
            emailId8: null,
            emailId9: null,
            emailId10: null,
            phoneNumber: null,
            roleId: 4,
            address: 'Daikin Texas Technology Park, 19001 Kermier Road',
            adminId: 235726,
            superAdminId: null,
            blocked: false,
            webId: '471a9dba-5e94-457d-82d7-63773fdaa675',
            fullCount: null,
            category: null,
            devices: null,
            averageRating: 0,
            oneRating: null,
            twoRating: null,
            threeRating: null,
            fourRating: null,
            fiveRating: null,
            ratingCount: null,
            totalReview: null,
            businessName: 'Daikin Comfort Technologies North America, Inc.',
            pincode: 77484,
            jobCountBetweenAssociateUsers: null,
            businessOwnerIdUrl: null,
            businessCertificateUrl: null,
            corporateIdentificationNumber: null,
            restrictedJobType: null,
            permittedJobType: [],
            inchargeDepartment: '',
            inchargePerson: '',
            businessNameReport: null,
            stateReport: null,
            cityReport: null,
            addressReport: null,
            pincodeReport: null,
            digitalSignature: null,
            signatureDisplay: false,
            parent: null,
          },
        },
      ]

    default:
      return []
  }
}

export { userWiseRole, childUsers, userDataList }
